const Copy = ({
  className,
  onClick,
}: {
  className: string;
  onClick?: () => void;
}) => {
  return (
    <svg
      className={className}
      onClick={onClick}
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M6.5 2.3C6.5 1.30589 7.30589 0.5 8.3 0.5H15.7C16.6941 0.5 17.5 1.30589 17.5 2.3V11.7C17.5 12.6941 16.6941 13.5 15.7 13.5H12.5V6.5C12.5 4.84315 11.1568 3.5 9.49996 3.5H6.5V2.3Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.5 6.5C0.5 5.39543 1.39543 4.5 2.5 4.5H9.5C10.6046 4.5 11.5 5.39543 11.5 6.5V15.5C11.5 16.6046 10.6046 17.5 9.5 17.5H2.5C1.39543 17.5 0.5 16.6046 0.5 15.5V6.5ZM2.5 6H9.5C9.77614 6 10 6.22386 10 6.5V15.5C10 15.7761 9.77614 16 9.5 16H2.5C2.22386 16 2 15.7761 2 15.5V6.5C2 6.22386 2.22386 6 2.5 6Z"
      />
    </svg>
  );
};

export default Copy;
